export const description =
  'Simulez toutes vos aides énergétiques adaptées à votre profil : MaPrimeRénov’, primes CEE, éco-PTZ, PCAE, Fonds Vert. Résultat immédiat et gratuit.';
